import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.function.name.js";
var LinkedTabs = function LinkedTabs() {
  return import('@/components/organisms/LinkedTabs');
};
var LinkedTabsItemRound = function LinkedTabsItemRound() {
  return import('@/components/molecules/LinkedTabsItemRound');
};
export default {
  components: {
    LinkedTabs: LinkedTabs,
    LinkedTabsItemRound: LinkedTabsItemRound
  },
  props: {
    questType: {
      type: Number,
      default: function _default() {
        return 0;
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    isNormalQuest: function isNormalQuest() {
      return this.questType == useQuestStore().getQuestTypes.normalQuest;
    },
    isLandQuest: function isLandQuest() {
      return this.questType == useQuestStore().getQuestTypes.landQuest;
    },
    isCooperationQuest: function isCooperationQuest() {
      return this.questType == useQuestStore().getQuestTypes.cooperationQuest;
    },
    isEventQuest: function isEventQuest() {
      return this.questType == useQuestStore().getQuestTypes.eventQuest;
    },
    isGacha: function isGacha() {
      return this.questType == useQuestStore().getQuestTypes.gacha;
    }
  },
  beforeMount: function beforeMount() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {},
  methods: {
    isActive: function isActive(path) {
      return this.$route.name.includes(path);
    }
  }
};